<template>
  <div class="modal-goodslist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">护理等级修改</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="名称" required prop="name">
                  <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="排序" required prop="sort">
                  <el-input v-model="editForm.sort" placeholder="请输入排序"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="护理项目" required prop="itemCodeArr">
                  <el-select v-model="editForm.itemCodeArr" style="width:100%" multiple placeholder="请选择护理项目">
                    <el-option
                        v-for="item in ItemList"
                        :key="item.nursingItemCode"
                        :label="item.name"
                        :value="item.nursingItemCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="价格" required prop="price">元/{{chargeTime}}
                  <el-input type="number" v-model="editForm.price" placeholder="请输入价格"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="护理等级状态" required prop="status">
                  <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%">
                    <el-option
                        v-for="item in status2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,getChargeTime} from "@/utils/auth";


export default {
  name: 'Edit',
  props:['ItemList'],
  data() {
    return {
      loading: false,
      chargeTime:'',
      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
        nursingLevelCode:'',
        sort:'',
        status:0,
        itemCodeArr:[],
        price:''
      },
      status2: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '被禁用'
      }],
      rules:{
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        itemCodeArr:[
          { required: true, message: '请选择护理项目', trigger: 'blur' },
        ],
        sort:[
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        price:[
          { required: true, message: '请输入价格', trigger: 'blur' },
          {
            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
            message: "小数点后最多只能输入两位", trigger: 'blur'
          }
        ],
      }

    }
  },

  methods: {

    init(row){
      this.editForm.nursingLevelCode = row.nursingLevelCode;
      var itemCodeArr=[]
      row.nursingItemList.forEach(element => {
        itemCodeArr.push(element.nursingItemCode)
      });
      this.editForm.itemCodeArr=itemCodeArr
      this.editForm.name = row.name;
      this.editForm.sort = row.sort;
      this.editForm.status = row.status;
      this.editForm.price = row.price;
      if(getChargeTime()=='天'){
        this.editForm.price = row.price;
      }else{
        this.editForm.price = row.priceMonth;
      }
      this.chargeTime = getChargeTime();
    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })


    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingLevel/Edit",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;

            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

  }
}


</script>





<style lang="scss" scoped>

.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
